import { Button } from '@apollo/orbit';
import React, { useState } from 'react';

import { SchemaInfo } from 'src/app/graph/documentationPage/sdlPage/sdlDisplay/SDLDisplay';

import { FieldPageSDLModal } from '../fieldPageSDLModal/FieldPageSDLModal';

interface Props {
  schemaInfo: SchemaInfo | null;
}

export const FieldPageSDLButton = ({ schemaInfo }: Props) => {
  const [modalOpen, setModalOpen] = useState(false);

  return !schemaInfo ? null : (
    <>
      <Button
        variant="secondary"
        onClick={() => setModalOpen(true)}
        data-analytics-category="Field Insights"
        data-analytics-label="View raw SDL button click"
      >
        View SDL
      </Button>

      {modalOpen && (
        <FieldPageSDLModal
          isOpen
          schemaInfo={schemaInfo}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};
